//--------------------------------------------------------------------------------------
// ===| THIS IS THE JS FOR THE CUSTOM EBOOK STEPWIZARD FORM |===
//--------------------------------------------------------------------------------------

var navListItems = document.querySelectorAll('div.setup-panel div a');
var allWells = document.querySelectorAll('.setup-content');
var allNextBtn = document.querySelectorAll('.nextBtn');
var allPrevBtn = document.querySelectorAll('.prevBtn');

allWells.forEach(function(well) {
  well.style.display = 'none';
});

navListItems.forEach(function(item) {
  item.addEventListener('click', function(e) {
    e.preventDefault();
    var targetId = this.getAttribute('href').substring(1); // Remove the '#' symbol
    var target = document.getElementById(targetId);

    if (!this.classList.contains('disabled')) {
      navListItems.forEach(function(navItem) {
        navItem.classList.remove('btn-primary');
        navItem.classList.add('btn-default');
      });

      this.classList.remove('btn-default');
      this.classList.add('btn-primary');

      allWells.forEach(function(well) {
        well.style.display = 'none';
      });

      target.style.display = 'block';
    }
  });
});



//-----------------------------------------------------------------------------------------------------------
// ===| CHECKS FOR VALID EMAIL ADDRESS FORMAT (HTML5 VALIDATION DOESN'T PREVENT ADVANCING TO NEXT STEP) |===
//-----------------------------------------------------------------------------------------------------------
function validateEmail(id) {
    var email_regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
    var inputElement = document.getElementById(id);

    if (!email_regex.test(inputElement.value)) {
        var div = inputElement.closest("div");

        div.classList.remove("has-success");
        var glypcn = document.getElementById("glypcn" + id);
        if (glypcn) {
            div.removeChild(glypcn);
        }

        div.classList.add("has-error", "has-feedback");
        var span = document.createElement("span");
        span.id = "glypcn" + id;
        span.className = "glyphicon glyphicon-remove form-control-feedback";
        div.appendChild(span);

        return false;
    } else {
        var div = inputElement.closest("div");

        div.classList.remove("has-error");
        var glypcn = document.getElementById("glypcn" + id);
        if (glypcn) {
            div.removeChild(glypcn);
        }

        div.classList.add("has-success", "has-feedback");
        var span = document.createElement("span");
        span.id = "glypcn" + id;
        span.className = "glyphicon glyphicon-ok form-control-feedback";
        div.appendChild(span);

        return true;
    }
}

// Event listener for the step-2 .nextBtn
document.querySelector("#step-2 .nextBtn").addEventListener("click", function() {
    if (!validateEmail("txtEmail")) {
        return false;
    }
});



//-------------------------------------------------------------------------------------------
// ===| CHECKS FOR VALIDATION OF REQUIRED FORM FIELDS AND PREVENTS ADVANCING IF INVALID |===
//-------------------------------------------------------------------------------------------

function validateAndNavigateToNextStep(nextBtn) {
  var curStep = nextBtn.closest(".setup-content");
  var curStepBtn = curStep.id;

  // Find the corresponding navigation link based on curStepBtn
  var navLinkSelector = 'div.setup-panel div a[href="#' + curStepBtn + '"]';
  var navLink = document.querySelector(navLinkSelector);

  if (navLink) {
    var parentPanel = navLink.parentNode;
    var nextSiblingPanel = parentPanel.nextElementSibling;

    if (nextSiblingPanel) {
      var nextStepWizard = nextSiblingPanel.querySelector("a");
      var curInputs = curStep.querySelectorAll("input[type='text'],input[type='url'],input[type='email'],input[type='radio'],input[type='date'],input[type='number'],select[class='form-control'],select[required],select[required='required']");
      var isValid = true;

      // Remove 'has-error' class from all '.form-group' elements
      var formGroups = document.querySelectorAll(".form-group");
      formGroups.forEach(function (formGroup) {
        formGroup.classList.remove("has-error");
      });

      for (var i = 0; i < curInputs.length; i++) {
        if (curInputs[i].id === 'courseEnrollment') {
          // Check if the value is zero or less
          if (parseInt(curInputs[i].value) <= 0) {
            isValid = false;
            curInputs[i].closest(".form-group").classList.add("has-error");
          } else {
            curInputs[i].closest(".form-group").classList.remove("has-error");
          }
        } else if (!curInputs[i].validity.valid) {
          isValid = false;
          curInputs[i].closest(".form-group").classList.add("has-error");
        }
      }

      if (isValid) {
        nextStepWizard.removeAttribute('disabled');
        nextStepWizard.click();
      }
    }
  }
}

// Get all elements with class 'nextBtn'
var allNextBtn = document.querySelectorAll('.nextBtn');

allNextBtn.forEach(function (nextBtn) {
  nextBtn.addEventListener('click', function () {
    validateAndNavigateToNextStep(nextBtn);
  });
});


// Get all elements with class 'prevBtn'
var allPrevBtn = document.querySelectorAll('.prevBtn');

// Attach a click event listener to each 'prevBtn' element
allPrevBtn.forEach(function(prevBtn) {
    prevBtn.addEventListener('click', function() {
        var curStep = prevBtn.closest(".setup-content");
        var curStepBtn = curStep.id;
        var prevStepWizard = document.querySelector('div.setup-panel div a[href="#' + curStepBtn + '"]').parentNode.previousElementSibling.querySelector("a");
        
        prevStepWizard.removeAttribute('disabled');
        prevStepWizard.click();
    });
});

// Trigger a click event on the first 'div.setup-panel div a.btn-primary' element
var firstBtnPrimary = document.querySelector('div.setup-panel div a.btn-primary');
if (firstBtnPrimary) {
    firstBtnPrimary.click();
}


//-----------------------------
// ===| ADD/REMOVE TITLES |===
//-----------------------------
// Initialize subjectRowIndex
var subjectRowIndex = 0;

// Function to toggle subject row visibility
function toggleSubjectRowVisibility(row, isVisible) {
    var subjectRow = document.getElementById('subject' + row);
    if (subjectRow) {
        if (isVisible) {
            subjectRow.classList.remove('hidden');
        } else {
            subjectRow.classList.add('hidden');
            resetProductInfo(row);
        }
    }
}

// Function to reset product info for a given row
function resetProductInfo(row) {
    // List of input IDs for each subject row
    const inputIds = [
        'txtFinalAuthor',
        'txtFinalTitle',
        'txtFinalIsbn',
        'txtFinalChapter',
        'txtFinalChapterOrder'
    ];

    // Loop through all input IDs and reset values for the specified row
    inputIds.forEach(inputId => {
        var inputElement = document.getElementById(inputId + (row + 1)); // Adding 1 to row to match the input IDs
        if (inputElement) {
            inputElement.value = "";
        }
    });
}


// Function to add or remove subject rows
function toggleSubjectRows(action) {
    if (action === 'add' && subjectRowIndex < 2) {
        subjectRowIndex++;
    } else if (action === 'remove' && subjectRowIndex > 0) {
        subjectRowIndex--;
    }

    // Toggle visibility of subject rows
    toggleSubjectRowVisibility(subjectRowIndex, true);
    toggleSubjectRowVisibility(subjectRowIndex + 1, false);

    // Toggle button states based on subjectRowIndex
    document.getElementById('add-subject-row').classList.toggle('disabled', subjectRowIndex === 2);
    document.getElementById('delete-subject-row').classList.toggle('disabled', subjectRowIndex === 0);
}

// Function to handle Add Title button click
function handleAddTitleClick() {
    toggleSubjectRows('add');
}

// Function to handle Remove Title button click
function handleRemoveTitleClick() {
    toggleSubjectRows('remove');
}

// Initialize Add Title and Remove Title button click events
document.getElementById('add-subject-row').addEventListener('click', handleAddTitleClick);
document.getElementById('delete-subject-row').addEventListener('click', handleRemoveTitleClick);


// Prevent the default behavior of the anchor link
function disableDefaultClick(event) {
  event.preventDefault();
}


//ADD OR REMOVE REQUIRED ATTRIBUTE BASED ON VISIBILITY
// Function to update required attributes
function updateRequiredAttributes() {
  // Check if subject1 is hidden
  const subject1 = document.getElementById('subject1');
  const isSubject1Hidden = subject1.classList.contains('hidden');

  // Update required attributes for subject1 fields
  const fieldsSubject1 = ['txtFinalAuthor2', 'txtFinalTitle2', 'txtFinalIsbn2', 'txtFinalChapter2'];
  fieldsSubject1.forEach(fieldId => {
    const field = document.getElementById(fieldId);
    if (isSubject1Hidden) {
      field.removeAttribute('required');
    } else {
      field.setAttribute('required', 'required');
    }
  });

  // Check if subject2 is hidden
  const subject2 = document.getElementById('subject2');
  const isSubject2Hidden = subject2.classList.contains('hidden');

  // Update required attributes for subject2 fields
  const fieldsSubject2 = ['txtFinalAuthor3', 'txtFinalTitle3', 'txtFinalIsbn3', 'txtFinalChapter3'];
  fieldsSubject2.forEach(fieldId => {
    const field = document.getElementById(fieldId);
    if (isSubject2Hidden) {
      field.removeAttribute('required');
    } else {
      field.setAttribute('required', 'required');
    }
  });
}

// Function to handle visibility change
function handleVisibilityChange() {
  updateRequiredAttributes();
}

// Add event listeners to trigger updateRequiredAttributes when either button is clicked
document.getElementById('add-subject-row').addEventListener('click', function(event) {
  event.preventDefault();
  handleVisibilityChange(); // Update required attributes after changing visibility
});

document.getElementById('delete-subject-row').addEventListener('click', function(event) {
  event.preventDefault();
  handleVisibilityChange(); // Update required attributes after changing visibility
});
